<template>
  <div class="wa-loading" v-loading="true" element-loading-background="rgba(255, 255, 255, 1)"></div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getUserInfoBySession } from '@/api/whatsapp'
import { Storage } from '@/utils/storage'

const router = useRouter()
const route = useRoute()

const WA_LOGIN_STORAGE_KEY = 'wa_login_user'
const WA_MANUAL_LOGOUT_KEY = 'wa_manual_logout'

const saveWaLoginUser = (user) => {
  try {
    Storage.set(WA_LOGIN_STORAGE_KEY, user || {})
  } catch (e) {
  }
}

const clearWaLoginUser = () => {
  try {
    Storage.remove(WA_LOGIN_STORAGE_KEY)
  } catch (e) {
  }
}

const parseUserInfoResult = (res) => {
  const payload = res?.result || res?.data?.result || res?.data || res
  return {
    id: payload?.id,
    pushName: payload?.pushName,
    name: payload?.name || payload?.pushName,
    picture: payload?.picture
  }
}

const gotoLogin = () => {
  router.replace({
    path: '/whatsapp/walogin',
    query: {
      ...(route.query || {}),
      skipLoading: '1'
    }
  })
}

onMounted(async () => {
  try {
    const manualLogoutAt = Storage.get(WA_MANUAL_LOGOUT_KEY)
    if (manualLogoutAt) {
      clearWaLoginUser()
      gotoLogin()
      return
    }
  } catch (e) {
  }

  try {
    const res = await getUserInfoBySession({}, { errorPop: false })
    const info = parseUserInfoResult(res)
    if (info?.id && (info?.name || info?.pushName)) {
      saveWaLoginUser({
        id: info?.id,
        pushName: info?.pushName,
        name: info?.name || info?.pushName,
        picture: info?.picture
      })
      router.replace('/whatsapp/wahome')
      return
    }
  } catch (e) {
  }

  clearWaLoginUser()
  gotoLogin()
})
</script>

<style scoped>
.wa-loading {
  width: 100%;
  height: calc(100vh - 48px);
  background: #fff;
}
</style>
